import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=59a653dd&scoped=true"
import script from "./Wait.vue?vue&type=script&lang=js"
export * from "./Wait.vue?vue&type=script&lang=js"
import style0 from "./Wait.vue?vue&type=style&index=0&id=59a653dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a653dd",
  null
  
)

export default component.exports